var socialStory;

function stretchMidcats() {
	var min_height = 0;
	var midcats = document.getElementsByClassName("category-listing__item");
	Array.prototype.forEach.call(midcats, function (el) {
		el.style.height = "inherit";
	});
	Array.prototype.forEach.call(midcats, function (el) {
		if (el.scrollHeight > min_height) {
			min_height = el.scrollHeight;
		}
	});
	Array.prototype.forEach.call(midcats, function (el) {
		el.style.height = min_height + "px";
	});
}

function manageThumbnailBox(id) {
    var floatingImage = document.getElementById("floating-image-gaiia");
    var mainPicture = document.getElementById("main-picture-gaiia");
    var loadingIcon = document.querySelector(".image-loading-icon");
    var thumbnail = document.querySelector(".main-floating-images.thumbnail");
    var presentationBlock = document.querySelector('.zoomImg');

    if(floatingImage) {
        if (id === "floating-image-gaiia") {
            floatingImage.style.display = "block";
            mainPicture.style.display = "none";
            loadingIcon.style.display = "none";
            presentationBlock.src = "";
        } else {
            floatingImage.style.display = "none";
            mainPicture.style.display = "block";
            loadingIcon.style.display = "block";
            thumbnail.classList.add("selected");
        }
    }
}

$(".floating-image-gaiia").click(function () {
	manageThumbnailBox("floating-image-gaiia");
});
$(".main-picture-gaiia").click(function () {
	manageThumbnailBox("main-picture-gaiia");
});

function manageGizzmoThumbnailBox(id){
	var floatingImage = document.getElementById("main-floating-images-gizzmo");
    var mainPicture = document.getElementById("main-picture");
    var loadingIcon = document.querySelector(".image-loading-icon");
    var thumbnail = document.querySelector(".main-floating-images.thumbnail");
	var badges = document.getElementById("gallery-badges");

    if(floatingImage) {
		$(".main-picture-container").trigger("zoom.destroy");
        if (id === "floating-image-gizzmo") {
            floatingImage.style.display = "block";
            mainPicture.style.display = "none";
            loadingIcon.style.display = "none";
			badges.style.display = "block";
        } else {
            floatingImage.style.display = "none";
            mainPicture.style.display = "block";
            loadingIcon.style.display = "block";
            thumbnail.classList.add("selected");
			badges.style.display = "none";
        }
    }
}

$(".floating-image-gizzmo").click(function () {
	manageGizzmoThumbnailBox("floating-image-gizzmo");
});
$(".thumbnail-container .main-picture").click(function () {
	manageGizzmoThumbnailBox("main-picture");
});

function stretchProducts() {
	var min_height = 0;
	var products = document.getElementsByClassName("listing__product");
	Array.prototype.forEach.call(products, function (el) {
		if(el.dataset.height != "skip") {
			el.style.height = "inherit";
		}
	});
	Array.prototype.forEach.call(products, function (el) {
		if (el.scrollHeight > min_height && el.dataset.height != "auto" && el.dataset.height != "skip") {
			min_height = el.scrollHeight;
		}
	});
	Array.prototype.forEach.call(products, function (el) {
		if(el.dataset.height != "skip") {			
			el.style.height = min_height + 30 + "px";
	
			if(window.jstransobj.locale == "hr") {
				el.style.height = min_height + 30 + 10 + "px";
			}
		}

		if(el.dataset.height == "auto") {
			el.style.height = "auto";
		}
	});
}

function midCatStarRatings() {
	$(".midcat-starRating").each(function () {
		$(this).starRating({
			initialRating: $(this).data("score"),
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 18,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: true,
		});
	});
}

$(".default-starRating").each(function () {
	$(this).starRating({
		initialRating: $(this).data("score"),
		strokeColor: "#f2f2f2",
		strokeWidth: 10,
		starSize: 22,
		useGradient: false,
		emptyColor: "#f2f2f2",
		hoverColor: "#ffd969",
		activeColor: "#ffd969",
		readOnly: true,
	});
});

/* ===========================LISTING=========================== */
$(function () {
	var stretchProductsTimeout = null;
	stretchMidcats();
	// stretchProducts();

	window.addEventListener("load", function () {
		stretchProducts();
		stretchMidcats();
	});

	var windowWidth = window.innerWidth;

	window.addEventListener(
		"resize",
		function (e) {
			if (window.innerWidth != windowWidth) {
				stretchMidcats();
			}

			if (window.innerWidth != windowWidth) {
				clearTimeout(stretchProductsTimeout);
				stretchProductsTimeout = setTimeout(stretchProducts, 500);
			}

			if (window.innerWidth != windowWidth) {
				windowWidth = window.innerWidth;
			}
		},
		false
	);

	midCatStarRatings();
});

/* ===========================FOOTER=========================== */

/*(function(){
    var cnjobj = {
    Key: 'Cro_833',
    Type: 'badge',
    Color: '',
    Size: '100',
    BadgeClassName: 'trustMark'
    };
    var cnjho = document.createElement('script');
    cnjho.async = true;
    cnjho.type = 'text/javascript';
    cnjho.src = "https://cpx.smind.hr/Log/LogData?data=" + JSON.stringify(cnjobj);
    var cnjs = document.getElementsByTagName('script')[0];
    cnjs.parentNode.insertBefore(cnjho, cnjs);
})();*/
(function () {
	if (["hr", "si"].indexOf(window.jstransobj.locale) === -1) {
		return;
	}
	var obj = {
		Key: "Slo_1183",
		Type: "badge",
		Color: "",
		Size: "54",
		BadgeClassName: "trustMark",
	};
	if (window.jstransobj.locale == "hr") {
		obj.Key = "Cro_833";
	}
	var ho = document.createElement("script");
	ho.async = true;
	ho.type = "text/javascript";
	if (window.jstransobj.locale == "hr") {
		ho.src = "https://cpx.smind.hr/Log/LogData?data=" + JSON.stringify(obj);
	} else {
		ho.src = "https://cpx.smind.si/Log/LogData?data=" + JSON.stringify(obj);
	}
	ho.onload = function () {
		$(".trustMark a").attr("rel", "noopener");
	};
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(ho, s);
})();

$("#return-to-top").click(function () {
	// When arrow is clicked
	$("body,html").animate(
		{
			scrollTop: 0, // Scroll to top of body
		},
		500
	);
});

$(function () {
	$(".rating-badge-pair").hover(function (e) {
		e.preventDefault();
	});
});

$(function () {
	if ($("#searchfield__input").length) {
		var previous_result = null;
		var hasResults = false;
		var searchResultsTimeoutId = null;
		var didSelect = false;
		var ajaxCall = null;

		$("#searchfield__input")
			.autocomplete({
				source: function (request, response) {
					if (ajaxCall !== null) {
						ajaxCall.abort();
					}

					ajaxCall = $.ajax({
						url: window.jstransobj.linkPrefix + "/search/get/" + window.jstransobj.locale,
						dataType: "json",
						type: "GET",
						data: {
							term: request.term,
						},
						success: function (data) {
							$("#view-all-results").attr(
								"href",
								$("#view-all-results").data("href").replace("%string%", $("#searchfield__input").val())
							);
							// $('.searchfield__input').val(request.term);
							response(data.results);

							clearTimeout(searchResultsTimeoutId);
							searchResultsTimeoutId = setTimeout(function () {
								if (data.results != null && data.totalHits != null) {
									$("#searchfield").addClass("results-found");
									$("#view-all-results-text").html(
										$("#view-all-results-text")
											.data("text")
											.replace("%count%", "<span class='bold'>" + data.totalHits + "</span>")
									);
									$("#view-all-results-text").show();
									var textWidth = $("#view-all-results-text").width();

									if (!hasResults) {
										$("#view-all-results-text").hide();
									}
									hasResults = true;

									$("#view-all-results").animate(
										{
											width: textWidth + 60 + "px",
										},
										600,
										function () {
											setTimeout(function () {
												$("#view-all-results-text").fadeIn();
											}, 600);
										}
									);

									$("#view-all-results").attr(
										"href",
										$("#view-all-results").data("href").replace("%string%", request.term)
									);
								} else {
									$("#view-all-results-text").hide();
									$("#view-all-results-text").html("");
									$("#view-all-results").css("width", "inherit");
									hasResults = false;
								}
							}, 1000);
						},
					});
				},
				minLength: 2,
				select: function (event, ui) {
					didSelect = true;
					if (ui.item.desc === "result-label") {
						return false;
					}
					var cleaned = ui.item.label.replace("<span class='bold'>", "");
					cleaned = cleaned.replace("</span>", "");
					$(event.target).val(cleaned);
					window.location = ui.item.values;
					return false;
				},
				focus: function (event, ui) {
					event.preventDefault();

					if (typeof ui.item !== "undefined") {
						if (ui.item.values != "/") {
							if ($.trim($(this).val()) != "") {
								var currentItem = $(".ui-menu").find('[data-value="' + ui.item.values + '"]');

								if (currentItem.hasClass("result-label")) {
									var e = event.keyCode == 40 ? jQuery.Event("keydown") : jQuery.Event("keydown");
									e.keyCode = event.keyCode == 40 ? 40 : 38;
									$(this).trigger(e);
									return;
								}

								var cleaned = ui.item.label.replace("<span class='bold'>", "");
								cleaned = cleaned.replace("</span>", "");

								if (previous_result !== null) {
									previous_result.removeClass("active");
								}
								previous_result = $(".ui-menu").find('[data-value="' + ui.item.values + '"]');
								previous_result.addClass("active");
							} else {
								if (typeof _errs == "object") {
									_errs.push(new Error("Item is null on search string: " + $("#searchfield__input").val()));
								}
							}
						}
					}
				},
				open: function (event, ui) {
					$(".submenu").addClass("block-visibility");
				},
				close: function (event, ui) {
					$(".submenu").removeClass("block-visibility");
				},
				search: function (event, ui) {
					if ($.trim($(".searchfield__input").val()) == "") {
						return false;
					}
				},
				create: function (event, ui) {
					$(".ui-autocomplete").unbind("menufocus");
				},
			})
			.data("ui-autocomplete")._renderItem = function (ul, item) {
			if (item.desc === "smallcat") {
				return $("<li class='smallcat searchable'>").attr("data-value", item.values).append(item.label).appendTo(ul);
			}
			if (item.desc === "result-label") {
				return $("<li class='result-label'>").attr("data-value", item.values).append(item.label).appendTo(ul);
			}

			return $("<li class='class searchable'>").attr("data-value", item.values).append(item.label).appendTo(ul);
		};
		$("#searchfield__input").prop("disabled", false);

		$("#searchfield__input").keydown(function (event) {
			if (event.keyCode == 13 && !didSelect) {
				if ($.trim($(this).val()) != "") {
					window.location.href = window.jstransobj.linkPrefix + "/search?q=" + $.trim($(this).val());
				}
			}
		});
		$("#searchfield__input").keyup(function (event) {
			if ($.trim($(this).val()).length < 2) {
				$("#view-all-results-text").hide();
				$("#view-all-results-text").html("");
				$("#view-all-results").css("width", "inherit");
			}
		});
	}
});

/* ===========================PRODUCT=========================== */

$("#sticky-selectbox").change(function (e) {
	$("#selectbox").val($(this).val());
	$("#selectquantityBottom").val($(this).val());
});
$("#selectquantityBottom").change(function (e) {
	$("#selectbox").val($(this).val());
	$("#sticky-selectbox").val($(this).val());
});

$("#selectbox").change(function (e) {
	$("#sticky-selectbox").val($(this).val());
	$("#selectquantityBottom").val($(this).val());
});

$("#addToCartBottom").on("click", function (e) {
	e.preventDefault();
	$("#add-to-cart").trigger("click");
});

$(function () {
	/* ------- NEW COMMENT ------ */
	if (typeof $(".starRatingNewComment").starRating != "undefined") {
		$(".starRatingNewComment").starRating({
			initialRating: 5,
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 35,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: false,
			disableAfterRate: false,
		});
	}

	if (typeof $(".batteryRatingNewComment").starRating != "undefined") {
		$(".batteryRatingNewComment").starRating({
			initialRating: 5,
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 35,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: false,
			disableAfterRate: false,
		});
	}

	if (typeof $(".conditionRatingNewComment").starRating != "undefined") {
		$(".conditionRatingNewComment").starRating({
			initialRating: 5,
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 35,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: false,
			disableAfterRate: false,
		});
	}

	if (typeof $(".deliveryRatingNewComment").starRating != "undefined") {
		$(".deliveryRatingNewComment").starRating({
			initialRating: 5,
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 35,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: false,
			disableAfterRate: false,
		});
	}

	$(".product__reviews .module__add-comment").on("click", function (e) {
		e.preventDefault();
		$("#newComment").slideDown();
	});

	$("#review-consent").on("click", function (e) {
		$(this).toggleClass("active");
	});

	$("#submitComment").on("click", function () {
		var name = $("#commentName").val().trim();
		var comment = $("#commentContent").val().trim();
		var email = $("#commentEmail").val().trim();
		var productid = $(this).data("id");

		if (typeof productid == "undefined") {
			productid = $("#pbq-wrapper").data("product-id");
		}

		if (name.length != 0 && comment.length != 0) {
			if (!$("#review-consent").hasClass("active")) {
				alert(window.jstransobj.confirmationIsMandatory);
				return false;
			}

			/* in case files are still being uploaded */
			if ($("#submitComment").hasClass("disabled")) {
				return;
			}

			var obj = {
				username: name,
				review: comment,
				email: email,
				rate: $("#newCommentRate").starRating("getRating"),
				conditionRate: $('#newCommentConditionRate').length > 0 ? $('#newCommentConditionRate').starRating('getRating') : null,
				batteryRate: $('#newCommentBatteryRate').length > 0 ? $('#newCommentBatteryRate').starRating('getRating') : null,
				deliveryRate: $('#newCommentDeliveryRate').length > 0 ? $('#newCommentDeliveryRate').starRating('getRating') : null,
			};

			if (!window.jstransobj) {
				window.jstransobj = { linkPrefix: "" };
			}

			$.ajax({
				cache: false,
				url: jstransobj.linkPrefix + "/product/" + productid + "/comment",
				method: "POST",
				data: obj,
				success: function (data) {
					data = JSON.parse(data);

					if ($("#uploadFileList .uploadedFile").length > 0) {
						$.ajax({
							cache: false,
							url: "https://media.wave.si/media.php",
							method: "POST",
							data: {
								productCommentId: data.productCommentId,
								temp_id: $("#newComment").attr("temp_id"),
								link_comment: "true",
							},
							success: function (data) {},
							error: function (data) {},
						});
					}

					alert(window.jstransobj.commentSuccessfullReview);
					setTimeout(function () {
						$("#newComment").slideUp("slow");
						$("#commentContent").val("");
						$("#commentName").val("");
						$("#commentEmail").val("");
						$("#uploadFileList").html("");
						$("#review-consent").removeClass("active");
					}, 200);
				},
				error: function (data) {
					alert(window.jstransobj.serverError);
					if (typeof _errs == "object") {
						_errs.push(new Error(data.responseText));
					}
				},
			});
		} else {
			if ((name.length == 0 && comment.length != 0) || (name.length != 0 && comment.length == 0)) {
				alert(window.jstransobj.commentFieldsNotFilledError);
			} else {
				var obj = {
					rate: $("#newCommentRate").starRating("getRating"),
				};

				if (!window.jstransobj) {
					window.jstransobj = { linkPrefix: "" };
				}

				$.ajax({
					cache: false,
					url: jstransobj.linkPrefix + "/product/" + productid + "/rating",
					method: "POST",
					data: obj,
					success: function (data) {
						alert(window.jstransobj.ratingSuccessfullReview);
						setTimeout(function () {
							$("#newComment").slideUp("slow");
							$("#commentContent").val("");
							$("#commentName").val("");
							$("#review-consent").removeClass("active");
						}, 200);
					},
					error: function (data) {
						alert(window.jstransobj.serverError);
						if (typeof _errs == "object") {
							_errs.push(new Error(data.responseText));
						}
					},
				});
			}
		}
	});

	var downloadProductsTimeout = null;
	window.addEventListener("scroll", function (e) {
		if ($(".product__reviews").length) {
			if ($(".product__reviews").isInViewport()) {
				if ($(".product__reviews").attr("isLoaded") !== "loaded") {
					clearTimeout(downloadProductsTimeout);
					downloadProductsTimeout = setTimeout(function () {
						$(".product__reviews").attr("isLoaded", "loaded");
						downloadProductReviewFiles();
					}, 300);
				}
			}
		}
	});

	function downloadProductReviewFiles() {
		$(".comment-uploads").each(function (index, element) {
			var _self = $(this);
			var id = $(element).data("id");
			$.ajax({
				url: "https://media.wave.si/media.php?get_files&commentId=" + $(element).data("id"),
				dataType: "json",
				success: function (data) {
					var imageUrl = "";
					if (data.length > 0) {
						videoThumbCounter = 0;
						if (typeof data[0].videos !== "undefined") {
							data[0].videos.forEach(function (el, index) {
								var attribute = "";
								el.forEach(function (video, video_index) {
									if (video.indexOf("webm") !== -1) {
										attribute += " data-webm-video='" + video + "' ";
									}
									if (video.indexOf("mp4") !== -1) {
										attribute += " data-mp4-video='" + video + "' ";
									}
								});

								if (typeof data[1][videoThumbCounter] !== "undefined") {
									// $(element).append( $('<div class="commentUploadedFileWrapper"><div class="story-wrapper"><div class="play"></div><img class="commentUploadedFile video-thumbnail lazyload" '+ attribute +' data-src="'+data[1][videoThumbCounter]+'" /></div></div>') );
									$(element)
										.find(".story-wrapper")
										.append(
											gizzmoStories
												.getPrototype()
												.replace("%image_url%", data[1][videoThumbCounter])
												.replace("%story_id%", id)
										);
								} else {
									$(element)
										.find(".story-wrapper")
										.append(
											$(
												'<img class="commentUploadedFile video lazyload" ' +
													attribute +
													' data-src="/assets/gizzmo/img/icons/icon-play.svg" />'
											)
										);
								}
								videoThumbCounter++;
							});
						}
						if (typeof data[0].images !== "undefined") {
							data[0].images.forEach(function (el, index) {
								imageUrl = el.split("/");
								imageUrl.splice(imageUrl.length - 1, 0, "image_thumbnails");
								imageUrl = imageUrl.join("/");
								$(element)
									.find(".story-wrapper")
									.append(gizzmoStories.getPrototype().replace("%image_url%", imageUrl).replace("%story_id%", id));
							});
						}

						if (typeof masonryGrid == 'object') {
							masonryGrid.masonry();
						}

						if (typeof data[0].videos === "undefined" && typeof data[0].images === "undefined") {
							_self.remove();
						}
					}
				},
			});
		});
	}

	// $('body').on('click', '.commentUploadedFile', function(e) {
	//     if($(this).hasClass('video') || $(this).hasClass('video-thumbnail')) {
	//         var $video = $('<video width="30%" height="auto" controls autoplay></video>');
	//         if($(this).attr('data-webm-video')) {
	//             $video.append('<source src="'+$(this).attr('data-webm-video')+'" type="video/webm">');
	//         }
	//         if($(this).attr('data-mp4-video')) {
	//             $video.append('<source src="'+$(this).attr('data-mp4-video')+'" type="video/mp4">');
	//         }
	//
	//         $video.appendTo('#waveModal');
	//         $('#waveModal').fadeIn();
	//     } else {
	//         var clone = $(this).clone();
	//         clone.attr('src', clone.data('originalSrc'));
	//         clone.appendTo('#waveModal');
	//         $('#waveModal').fadeIn();
	//     }
	// });
	//
	// $('body').on('click', '.comment-uploads .play', function(e) {
	//     $(this).siblings('.commentUploadedFile').trigger('click');
	// });
	//
	// $('#waveModal').on('click', function(e) {
	//     $(this).fadeOut(function() {
	//         $('#waveModal').html("");
	//     });
	// });

	function create_UUID() {
		var dt = new Date().getTime();
		var uuid = "xxxxxxxyxyxy".replace(/[xy]/g, function (c) {
			var r = (dt + Math.random() * 16) % 16 | 0;
			dt = Math.floor(dt / 16);
			return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
		});
		return uuid;
	}

	var temp_id = create_UUID();
	var dropbox;
	var waitForUploadInterval = null;

	dropbox = document.getElementById("newComment");
	if (dropbox) {
		dropbox.setAttribute("temp_id", temp_id);
		dropbox.addEventListener("dragenter", dragenter, false);
		dropbox.addEventListener("dragover", dragover, false);
		dropbox.addEventListener("drop", drop, false);
	}

	function dragenter(e) {
		e.stopPropagation();
		e.preventDefault();
	}

	function dragover(e) {
		e.stopPropagation();
		e.preventDefault();
	}

	function drop(e) {
		e.stopPropagation();
		e.preventDefault();

		var dt = e.dataTransfer;
		var files = dt.files;

		handleFiles(files);
	}

	function handleFiles(files) {
		var fileList = this.files || files; /* now you can work with the file list */
		var count = fileList.length < 5 ? fileList.length : 5;
		if ($(".uploadedFile").length < 5) {
			var idNumber = $(".uploadedFile").length ? $(".uploadedFile").length : 0;
			for (var i = 0; i < count; i++) {
				if ($(".uploadedFile").length > 5) {
					return;
				}
				/*https://cwestblog.com/2017/05/03/javascript-snippet-get-video-frame-as-an-image/*/
				if (fileList[i].type.startsWith("image/")) {
					var src = URL.createObjectURL(fileList[i]);
					var classList = "image";
				} else if (fileList[i].type.startsWith("video/")) {
					var src = "/assets/gizzmo/img/icons/icon-play.svg";
					var classList = "video";
				} else {
					alert(window.jstransobj.allowedFileFormats);
					return;
				}

				var $prototype = $($("#uploadFileList").data("prototype"));
				$prototype.attr("id", "upload" + idNumber);
				var $img = $prototype.find("img");
				$img[0].classList.add(classList);
				$img[0].src = src;
				$img[0].onload = function () {
					URL.revokeObjectURL(this.src);
				};
				$prototype.find(".file-name").html(fileList[i].name);
				$("#uploadFileList").append($prototype);

				var $removeElement = $prototype.find(".remove-upload");
				sendFile(fileList[i], idNumber, $removeElement, fileList[i].name);
				idNumber++;
			}
		} else {
			alert(window.jstransobj.maximumAllowedFiles);
		}
	}

	function sendFile(file, uploadId, $removeElement, fileName) {
		if ($("#uploadFileList").data("working") != "yes") {
			toggleLoadingAnimation("submitComment", [], "white");
			$("#submitComment").addClass("disabled");
		}

		if (waitForUploadInterval === null) {
			waitForUploadInterval = setInterval(function (e) {
				if ($('#uploadFileList [finished="yes"]').length == $("#uploadFileList .uploadedFile").length) {
					clearInterval(waitForUploadInterval);
					toggleLoadingAnimation("submitComment", [], "white");
					$("#submitComment").removeClass("disabled");
					waitForUploadInterval = null;
				}
			}, 500);
		}

		var uri = "https://media.wave.si/media.php";
		var xhr = new XMLHttpRequest();
		var fd = new FormData();

		xhr.open("POST", uri, true);
		xhr.onreadystatechange = function () {
			if (xhr.readyState == 4 && xhr.status == 200) {
				$removeElement.attr("finished", "yes");
			}
		};
		xhr.upload.addEventListener(
			"progress",
			function (e) {
				if (e.lengthComputable) {
					var percentage = Math.round((e.loaded * 100) / e.total);
					$("#upload" + uploadId)
						.find(".progress-bar")
						.width(percentage + "%");
				}
			},
			false
		);
		xhr.upload.addEventListener(
			"load",
			function (e) {
				$("#upload" + uploadId)
					.find(".upload-in-progress")
					.removeClass("upload-in-progress");
			},
			false
		);

		$removeElement.on("click", function (e) {
			$removeElement.parent(".uploadedFile").remove();
			if (xhr.readyState != 4) {
				xhr.abort();
			} else {
				$.ajax({
					cache: false,
					url: "https://media.wave.si/media.php",
					method: "POST",
					data: {
						fileName: fileName,
						temp_id: $("#newComment").attr("temp_id"),
						remove_file: true,
					},
					success: function (data) {},
					error: function (data) {},
					complete: function (data) {},
				});
			}
			$("#inputFile").val("");
		});

		fd.append("upload_file", "true");
		fd.append("myFile", file);
		fd.append("temp_id", temp_id);
		// Initiate a multipart/form-data upload
		xhr.send(fd);
	}

	inputElement = document.getElementById("inputFile");
	if (inputElement) {
		inputElement.addEventListener("change", handleFiles, false);
	}

	/* Category listing trigger */
	$(".category-listing__metadata a.module__readmore").on("click", function (e) {
		e.preventDefault();
		openCloseContent.call(this);
	});

	$(".product__reviews a.module__readmore").on("click", function (e) {
		e.preventDefault();
		openCloseContent.call(this);
	});

	$("" + 
		".footer-content-blocks a.module__readmore, " + 
		".what_is_tested a.module__readmore, " + 
		".category-rich-description a.module__readmore, " + 
		".bestsellers a.module__readmore, " + 
		".category-summary a.module__readmore" + 
		"").on(
		"click",
		function (e) {
			e.preventDefault();
			openCloseContent.call(this);
		}
	);

	

	/* ============ BULLETS ============== */

	function openCloseContent() {
		var $el = $(this).parents(".product__reviews").find(".add-gradient-after");
		if($el.length < 1){
			var $el = $(this).parent().find(".add-gradient-after");
		}
		var scrollTop = $(window).scrollTop();

		if ($(this).hasClass("open")) {
			scrollTop = $el.attr("scrollTop");
			$el.removeClass("open");
			$(this).removeClass("open");
			$el.animate({
				height: $el.data("height"),
			});
			$("body,html").animate({
				scrollTop: scrollTop,
			});
			if (typeof $(this).data("readMore") != "undefined") {
				$(this).text($(this).data("readMore"));
			}
		} else {
			$el.addClass("open");
			$(this).addClass("open");
			$el.attr("scrollTop", scrollTop);
			$el.animate(
				{
					height: $el[0].scrollHeight,
				},
				function () {
					$el.css("height", "auto");
				}
			);
			$("body,html").animate(
				{
					scrollTop: scrollTop,
				},
				500
			);
			if (typeof $(this).data("readLess") != "undefined") {
				$(this).text($(this).data("readLess"));
			}
		}
	}

	$(".product__description a.module__readmore").on("click", function (e) {
		e.preventDefault();
		openCloseContent.call(this);
	});

	$(".product__properties a.module__readmore").on("click", function (e) {
		e.preventDefault();
		openCloseContent.call(this);
	});

	/* Remove gradient if height is below limit */
	$(".add-gradient-after").each(function () {
		if (this.scrollHeight == $(this).data("height")) {
			$(this).removeClass("add-gradient-after");
			$(this).parent().css("min-height", "auto");
			$(this).parent().find("a.module__readmore").remove();
		}
	});

	(function () {
		var $productReviews = $(".product__reviews");
		if ($productReviews.length) {
			if (typeof $productReviews.data("commentCount") !== "undefined" && $productReviews.data("commentCount") == 0) {
				$productReviews.find("a.module__readmore").remove();
			}
		}
	})();

	// $('.product__reviews a').on('click', function(e) {
	//     e.preventDefault();
	//     openCloseContent.call(this);
	// });

	$(".product__main .star-rating").each(function () {
		$(this).starRating({
			initialRating: $(this).data("score"),
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 18,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: true,
		});
	});

	$(".product__reviews .star-rating").each(function () {
		var starSize = 18;
		if(typeof $(this).data("starSize") != "undefined" && $(this).data("starSize") != "") {
			starSize = $(this).data("starSize");
		}

		$(this).starRating({
			initialRating: $(this).data("score"),
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: starSize,
			useGradient: false,
			emptyColor: "#d2d3d7",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: true,
		});
	});

	$('.product__reviews .likes, .product__feautered-reviews .likes').on('click', function () {
		var productid = $(this).data('id');
		var commentId = $(this).data('comment-id');
		var thisElement = $(this);

		if(thisElement.data('isClicked') == 'yes') {
			return;
		} else {
			thisElement.parent().find('.likes').data('isClicked', 'yes');
		}

		if(commentId.length != 0){
			if(!window.jstransobj) {
				window.jstransobj = { linkPrefix : ""};
			}

			thisElement.text(parseInt(thisElement.text()) + 1);
			if(thisElement.hasClass('like')) {
				var img = document.createElement('img');
				img.src = thisElement[0].getAttribute('data-bg');
				img.classList.add('powerup');
				img.classList.add('animate__fadeOutUp');
				thisElement.append(img);
			} 

			$.ajax({
				url: jstransobj.linkPrefix + '/product/' + productid + "/like",
				method: 'POST',
				data: {commentId: commentId, isDislike: thisElement.hasClass('dislike') ? 'yes' : 'no' },
				error: function(data) {
					//alert(window.jstransobj.serverError);
					if (typeof _errs == 'object') {
						_errs.push(new Error(data.responseText));
					}
				}
			});
		}
	});

	$(".product__reviews .star-rating-reborn").each(function () {
		var starSize = 12;
		if(typeof $(this).data("starSize") != "undefined" && $(this).data("starSize") != "") {
			starSize = $(this).data("starSize");
		}

		$(this).starRating({
			initialRating: $(this).data("score"),
			strokeColor: "#18B284",
			strokeWidth: 10,
			starSize: starSize,
			useGradient: false,
			emptyColor: "#d2d3d7",
			hoverColor: "#18B284",
			activeColor: "#18B284",
			readOnly: true,
		});
	});

	$("#newProductRate_desktop").starRating({
		initialRating: $("#newProductRate_desktop").data("score"),
		strokeColor: "#f2f2f2",
		strokeWidth: 10,
		starSize: 24,
		useGradient: false,
		emptyColor: "#f2f2f2",
		hoverColor: "#ffd969",
		activeColor: "#ffd969",
		readOnly: true,
	});

	$(".product__subscribe a").on("click", function (e) {
		e.preventDefault();
	});

	/* =============== FAQ ================== */

	$(".product__faq__row, .product__faq-isolation__row").on("click", function (e) {
		e.preventDefault();

		$(".product__faq .answer").slideUp();
		$(".product__faq__row").find("img").removeClass("open");
		$(".product__faq__row").removeClass("product__faq__row--active");
		$(".product__faq__row").find("path").removeClass("active");

		var $next = $(this).next();
		if ($next.hasClass("answer")) {
			if ($next.css("display") == "none") {
				$next.slideDown();
				$(this).find("img").addClass("open");
				$(this).addClass("product__faq__row--active");
				$(this).find("path").addClass("active");
			} else {
				$next.slideUp();
				$(this).find("img").removeClass("open");
				$(this).removeClass("product__faq__row--active");
				$(this).find("path").removeClass("active");
			}
		}
	});

	$(".landing-faq__question").on("click", function (e) {
		e.preventDefault();
	
		var $clickedQuestion = $(this);
		var $answer = $clickedQuestion.next(".landing-faq__answer");
	
		// Close all other answers
		$(".landing-faq__answer").not($answer).slideUp();
		$(".landing-faq__question").not($clickedQuestion).removeClass("landing-faq__question--active");
	
		// Toggle the clicked question's answer
		if ($answer.is(":visible")) {
			$answer.slideUp();
			$clickedQuestion.removeClass("landing-faq__question--active");
		} else {
			$answer.slideDown();
			$clickedQuestion.addClass("landing-faq__question--active");
		}
	});

	

	if (typeof $.zoom === "function") {
		$(".main-picture-container").trigger("zoom.destroy"); // vedno rabimo na novo initiatat
		$(".main-picture-container").zoom();
	}

	$(".main-picture-container .main-picture").on("load", function () {
		$(".image-loading-icon").css("visibility", "hidden");
		$(".main-picture-container").trigger("zoom.destroy"); // vedno rabimo na novo initiatat
		$(".main-picture-container").zoom();
	});

	$(document).on("click", ".thumbnail", function () {
		var $parent = $(this).parents(".product__gallery");
		if ($(this).data("type") == "image") {
			$parent.find(".video-wrapper").html("");
			$parent.find(".image-wrapper").show();
			$parent.find(".video-wrapper").hide();

			$parent.find(".image-loading-icon").css("visibility", "visible");

			$parent.find(".thumbnail-container .thumbnail").removeClass("selected");
			$parent.find('.thumbnail[data-key="' + $(this).attr("data-key") + '"]').addClass("selected");

			$parent.find(".main-picture-container .main-picture").attr("data-src", $(this).find(".image").data("thumb-src"));
			$parent.find(".main-picture-container .main-picture").attr("src", $(this).find(".image").data("thumb-src"));
		} else if ($(this).data("type") == "video") {
			$parent.find(".main-picture-container").trigger("zoom.destroy");

			$parent.find(".image-wrapper").hide();
			$parent.find(".video-wrapper").show();

			$parent
				.find(".video-wrapper")
				.html('<div class="hytPlayerWrapOuter"><div class="hytPlayerWrap">' + $(this).data("videoFrame") + "</div></div>");
			registerYoutubeVideos();

			$parent.find(".thumbnail-container .thumbnail").removeClass("selected");
			$parent.find('.thumbnail[data-key="' + $(this).attr("data-key") + '"]').addClass("selected");
		}
	});

	if ($("#product-top-countdown").length != 0) {
		initializeClock("product-top-countdown", $("#product-top-countdown").data("countdownEnd"), function () {
			$("#product-top-countdown").remove();
		});
	}
	if ($("#product-bottom-countdown").length != 0) {
		initializeClock("product-bottom-countdown", $("#product-bottom-countdown").data("countdownEnd"), function () {
			$("#product-bottom-countdown").remove();
		});
	}

	if ($(".sticky-add-to-cart").length > 0) {
		$(window).scroll(function (e) {
			var bodyScrollTop = 0;
			if (typeof getBodyScrollTop !== "function") {
				var el = document.scrollingElement || document.documentElement;
				bodyScrollTop = el.scrollTop;
			} else {
				bodyScrollTop = getBodyScrollTop();
			}
			if ($(".add-to-cart-wrapper").length) {
				if ($(".add-to-cart-wrapper").isInViewport(-20)) {
					$(".sticky-add-to-cart").css("opacity", 0);
					$(".sticky-add-to-cart").hide();
				} else {
					if ($(window).scrollTop() > $(".add-to-cart-wrapper").offset().top) {
						$(".sticky-add-to-cart").show(400, function () {
							$(".sticky-add-to-cart").css("opacity", 1);
						});
					}
				}

				if (bodyScrollTop >= 74) {
					$(".sticky-add-to-cart").css("z-index", 10);
				} else {
					$(".sticky-add-to-cart").css("z-index", -10);
				}
			}
			// if ($("#stockSubscribe").length) {
			// 	if ($("#stockSubscribe").isInViewport(-20)) {
			// 		$(".sticky-add-to-cart").css("opacity", 0);
			// 	} else {
			// 		$(".sticky-add-to-cart").css("opacity", 1);
			// 	}

			// 	if (bodyScrollTop >= 74) {
			// 		$(".sticky-add-to-cart").css("z-index", 10);
			// 	} else {
			// 		$(".sticky-add-to-cart").css("z-index", -10);
			// 	}
			// }
		});
	}
	/* =============== Quantity discount ================== */
	$(".product__quantityDiscount .qd").click(function () {
		quantityDiscountUpdatePrices($(this));
	});
	function quantityDiscountUpdatePrices(element, updateSelector) {
		var quantity = element.data("qty");
		var oldPrice = element.data("old-price");
		var saving = element.data("saving");
		var savingPercent = element.data("saving-percent");
		var price = element.data("price");

		$(".product__quantityDiscount .qd").each(function () {
			if ($(this).data("qty") == quantity) {
				$(this).addClass("active");
			} else {
				$(this).removeClass("active");
			}
		});

		if (typeof quantity !== "undefined") {
			if (updateSelector !== false) {
				// $("select.select:not(#poptions)").each(function () {
				// 	$(this).val(quantity);					
				// });
				$("[data-update-quantity-selector]").val(quantity);
			}

			if (typeof oldPrice !== "undefined" && typeof saving !== "undefined" && typeof price !== "undefined") {
				if ($("#price-list .original-price").length > 0) {
					$("#price-list .original-price").html(oldPrice);
				}
				if ($("#price-list .saved-price .percent.basicDiscount .dprice").length > 0) {
					$("#price-list .saved-price .percent.basicDiscount .dprice").html("-" + savingPercent + " %");
				}
				if ($("#price-list .saved-price .percent").length > 0) {
					var discountElement = $("#price-list .saved-price .percent");
					if (discountElement.hasClass("basicDiscount")) {
						$("#price-list .saved-price .percent.basicDiscount .dprice").html("-" + savingPercent + " %");
					} else {
						if (!discountElement.hasClass("couponDiscount")) {
							discountElement.find(".dprice").html("-" + savingPercent + " %");
						}
					}
				}
				if ($("#price-list .saved-price .price").length > 0) {
					$("#price-list .saved-price .price").html(saving);
				}
				if ($("#price-list .pay-price").length > 0) {
					$("#price-list .pay-price").html(price);
				}

				if ($(".prices-wrapper .old-price").length > 0) {
					$(".prices-wrapper .old-price").html(oldPrice);
				}
				if ($(".prices-wrapper .price").length > 0) {
					$(".prices-wrapper .price").html(price);
				}
				if ($(".sticky-add-to-cart .oldPrice").length > 0) {
					$(".sticky-add-to-cart .oldPrice").html(oldPrice);
				}
				if ($(".sticky-add-to-cart .price").length > 0) {
					$(".sticky-add-to-cart .price").html(price);
				}
				if ($(".percentage-wrapper .bold").length > 0) {
					$(".percentage-wrapper .bold").html("-" + savingPercent + " %");
				}
				if ($(".product__gallery .main-picture-container .discount-ribbon").length > 0) {
					$(".product__gallery .main-picture-container .discount-ribbon").html("-" + savingPercent + " %");
				}
			}
		}
	}

	/* =============== Change quantity event ================== */
	$("select.select:not(#poptions)").change(function () {
		var quantity = $(this).val();
		if (typeof quantity != "undefined") {
			updateAllQuantitySelectors(quantity);
		}
	});
	function updateAllQuantitySelectors(quantity) {
		/* Select right quantity discount option */
		if ($(".product__quantityDiscount").length > 0) {
			var searchQuantity = quantity <= 3 ? quantity : 3;

			$(".product__quantityDiscount .qd").each(function () {
				if ($(this).data("qty") == searchQuantity) {
					$(this).addClass("active");
					quantityDiscountUpdatePrices($(this), false);
				} else {
					$(this).removeClass("active");
				}
			});
		}
	}
});

/* ===========================INDEX=========================== */

$(function () {
	$("#go-to-selected-model").on("click", function (e) {
		e.preventDefault();
		window.location = $("#model-selectbox").find(":selected").val();
	});

	$(".index__quick-offer").on("click", ".tab", function (e) {
		e.preventDefault();
		if ($(this).hasClass("active")) {
			return;
		}

		var current_list_id = $(".index__quick-offer .tab.active").attr("listing-el-id");
		var next_list_id = $(this).attr("listing-el-id");

		$(".index__quick-offer .tab").removeClass("active");
		$(this).addClass("active");

		$("#" + current_list_id)
			.css("opacity", "0")
			.css("z-index", "0");
		setTimeout(function () {
			$("#" + next_list_id)
				.css("opacity", "1")
				.css("z-index", "1");
		}, 100);
	});

	$(".horizontal-wrapper .box").on("touchstart", function () {
		$(this).find("img").css("opacity", "1");
	});

	$(".horizontal-wrapper .box").on("touchend", function () {
		$(this).find("img").css("opacity", ".5");
	});

	$(".review-container .star-rating").each(function () {
		$(this).starRating({
			initialRating: $(this).data("score"),
			strokeColor: "#f2f2f2",
			strokeWidth: 10,
			starSize: 18,
			useGradient: false,
			emptyColor: "#f2f2f2",
			hoverColor: "#ffd969",
			activeColor: "#ffd969",
			readOnly: true,
		});
	});

	$(".navigation.navigation__left, .navigation.navigation__right").on("click", function (e) {
		e.preventDefault();
	});

	$(".horizontal-wrapper-parent")
		.on("mouseenter", ".navigation", function (e) {
			var pixels = 0;
			var switch_direction = $(this).hasClass("navigation__right") ? true : false;
			var limit_right = $(document).width() - $(".horizontal-wrapper").width() - 120;
			var limit_left = 120;
			this.iid = setInterval(function () {
				pixels = parseInt($(".horizontal-wrapper").attr("data-pixels"));
				switch_direction ? (pixels += -20) : (pixels += 20);
				if (pixels >= limit_left || pixels <= limit_right) {
					return;
				}
				$(".horizontal-wrapper")[0].style.transform = "translate(" + pixels + "px, 0)";
				$(".horizontal-wrapper").attr("data-pixels", pixels);
			}, 50);
		})
		.on("mouseleave", ".navigation", function () {
			this.iid && clearInterval(this.iid);
		});

	if ($("#model-selectbox").length > 0) {
		$("#model-selectbox").selectpicker();
	}




	//landings

	$('.cta-landing').on('click', function(e) {
		//e.preventDefault();
	
		var target = $('.landing_all_devices');
		
		$('html, body').animate({
			scrollTop: target.offset().top
		}, 800);
	});

	function setActiveFilterButton() {
        var params = new URLSearchParams(window.location.search);
        var currentFilter = params.get('filter');
		var currentSorting = params.get('sorting');
        
        // Remove "active" class from all buttons
        $('.landing-filter-button').removeClass('active');
		$('.landing-sorting-button').removeClass('active');
        
        // Add "active" class to the button with the matching filter
        if (currentFilter) {
            $('.landing-filter-button[data-filter="' + currentFilter + '"]').addClass('active');
        }
		if (currentSorting) {
            $('.landing-sorting-button[data-sorting="' + currentSorting + '"]').addClass('active');
			buttonText = $('.landing-sorting-button[data-sorting="' + currentSorting + '"]').text();
			if(window.jstransobj.locale == "hr") {
				$('.sort_button').html("Redoslijed: " + buttonText);
			} else {
				$('.sort_button').html("Razvrščanje: " + buttonText);
			}
        } else{
			if(window.jstransobj.locale == "hr") {
				$('.sort_button').html("Poredaj");
			} else {
				$('.sort_button').html("Razvrsti");
			}
		}
    }

	function loadFilteredContent() {
        var params = new URLSearchParams(window.location.search);
        var filter = params.get('filter');
        var sort = params.get('sorting');
        var landingId = $('.landing-filter-button').data('landing-id');
		automatic = false;
		if(!filter){
			filter = 'vse_naprave';
			automatic = true;
		}

        if (filter) {
			$('.landing-modules-items').fadeOut(300, function() {
				// Once the fade out is complete, show the loading spinner
				$('.loading-spinner').fadeIn(300);
				$.ajax({
					url: jstransobj.linkPrefix + '/fetch-filtered-modules',
					type: 'GET',
					data: {
						filter: filter,
						sort: sort,
						landing_id: landingId
					},
					success: function(response) {

						$('.landing_all_devices .heading').html(response.heading);
						$('.landing_all_devices .subheading').html(response.subheading);
						$('.landing-modules-items').html(response.html);
						stretchProducts();

						if(!automatic){
							document.title = response.metaTitle;
							$('meta[name="description"]').attr('content', response.subheading);
						}
					},
					complete: function() {
						$('.loading-spinner').fadeOut(300, function() {
							$('.landing-modules-items').fadeIn(300);
						});
					}
				});
			});
        }
		setActiveFilterButton();
    }

	if (document.querySelector('.landing_all_devices') !== null) {
		setActiveFilterButton();
		loadFilteredContent();
	}

	$('.landing-filter-button').on('click', function(e) {
        e.preventDefault();
        var filter = $(this).data('filter'); // Get the filter value from the button
        var landingId = $(this).data('landing-id');
        var sort = $('.landing-sorting-button.active').data('sorting') || null;

		if ($(this).hasClass('active')) {
            filter = null; // Reset filter to show all devices
        }

        // Update the URL without reloading the page
        var newUrl = updateUrlParameter(window.location.href, 'filter', filter);
        newUrl = updateUrlParameter(newUrl, 'sorting', sort);
        window.history.pushState({ path: newUrl }, '', newUrl);

        // Load the filtered/sorted content
        loadFilteredContent(filter, sort, landingId);
    });

	$('.landing-sorting-button').on('click', function(e) {
        e.preventDefault();
        var sorting = $(this).data('sorting'); // Get the sorting value from the button
        var landingId = $(this).data('landing-id');
        var filter = $('.landing-filter-button.active').data('filter') || null;

        // Update the URL without reloading the page
        var newUrl = updateUrlParameter(window.location.href, 'sorting', sorting);
        newUrl = updateUrlParameter(newUrl, 'filter', filter);
        window.history.pushState({ path: newUrl }, '', newUrl);

        // Load the filtered/sorted content
        loadFilteredContent(filter, sorting, landingId);
    });

    // Function to update URL parameters
    function updateUrlParameter(url, param, paramVal) {
		var newAdditionalURL = "";
		var tempArray = url.split("?");
		var baseURL = tempArray[0];
		var additionalURL = tempArray[1];
		var temp = "";
	
		// Only add the parameter if it has a valid value (not null or undefined)
		if (paramVal) {
			if (additionalURL) {
				tempArray = additionalURL.split("&");
				for (var i = 0; i < tempArray.length; i++) {
					if (tempArray[i].split('=')[0] !== param) {
						newAdditionalURL += temp + tempArray[i];
						temp = "&";
					}
				}
			}
	
			var rows_txt = temp + "" + param + "=" + paramVal;
			return baseURL + "?" + newAdditionalURL + rows_txt;
		} else {
			// If the parameter value is null or undefined, just return the base URL without adding the parameter
			if (additionalURL) {
				tempArray = additionalURL.split("&");
				for (var i = 0; i < tempArray.length; i++) {
					if (tempArray[i].split('=')[0] !== param) {
						newAdditionalURL += temp + tempArray[i];
						temp = "&";
					}
				}
				return baseURL + "?" + newAdditionalURL;
			}
			return baseURL;
		}
	}


	var landingBanner = document.querySelector('.landing_banner:not(.landing_banner-leanpay)');

	if(landingBanner){
		var modal = landingBanner.querySelector("#videoModal");

		var modalContent = landingBanner.querySelector(".modal-content");
		var playButton = landingBanner.querySelector("#modalPlayButton");

		var trigger = landingBanner.querySelector(".right") || landingBanner.querySelector(".right-ipad");

		var closeModal = landingBanner.querySelector(".close");

		trigger.onclick = function() {
			modal.classList.add("show");
			var modalVideo = landingBanner.querySelector("#modalVideo");
			modalVideo.play();
		}

		closeModal.onclick = function() {
			modal.classList.remove("show");
			var modalVideo = landingBanner.querySelector("#modalVideo");
			modalVideo.pause();
		}

		modalVideo.addEventListener("click", function() {
			if (modalVideo.paused) {
				modalVideo.play();
				playButton.style.display = "none";
			} else {
				modalVideo.pause();
				playButton.style.display = "flex";
			}
		});

		playButton.addEventListener("click", function() {
			if (modalVideo.paused) {
				modalVideo.play();
				playButton.style.display = "none";
			} else {
				modalVideo.pause();
				playButton.style.display = "flex";
			}
		});

		modalVideo.addEventListener("play", function() {
			playButton.style.display = "none";
		});

		modalVideo.addEventListener("pause", function() {
			playButton.style.display = "flex";
		});

		window.onclick = function(event) {
			if (event.target == modalContent) {
				modal.classList.remove("show");
				var modalVideo = landingBanner.querySelector("#modalVideo");
				modalVideo.pause();
			}
		}
	}
});

/* ========= LARGE MENU ICON SWAPPING ========= */

(function () {
	var $largeMenuWrapper = $("#main-menu-wrapper");
	if ($largeMenuWrapper.length) {
		var modifyMenuTimer;
		var menuItemLength = 9;

		function modifyMenu() {
			var $groupWrappers = $largeMenuWrapper.find(".group__wrapper");
			$groupWrappers.each(function (gwindex, groupWrapper) {
				var $rows = $(groupWrapper).find("ul");
				if ($rows.length < 3) {
					if ($rows.length == 2) {
						if (window.innerWidth <= 1470) {
							menuItemLength = 9;
							if($largeMenuWrapper.data("gaiiaMenu") == "yes") {
								menuItemLength = 10;
							}

							if ($($rows[0]).find("li").length > menuItemLength) {
								$($rows[1]).prepend($($rows[0]).find("li").eq(menuItemLength));
							}
							$($rows[1])
								.find("li")
								.each(function (index, element) {
									if (index > (menuItemLength-1)) {
										$(element).remove();
									}
								});
						}

						if (window.innerWidth <= 1370) {
							menuItemLength = 8;
							if($largeMenuWrapper.data("gaiiaMenu") == "yes") {
								menuItemLength = 10;
							}

							if ($($rows[0]).find("li").length > menuItemLength) {
								$($rows[1]).prepend($($rows[0]).find("li").eq(menuItemLength));
							}
							$($rows[1])
								.find("li")
								.each(function (index, element) {
									if (index > (menuItemLength-1)) {
										$(element).remove();
									}
								});
						}

						if (window.innerWidth <= 1240) {
							menuItemLength = 7;
							if($largeMenuWrapper.data("gaiiaMenu") == "yes") {
								menuItemLength = 9;
							}

							if ($($rows[0]).find("li").length > menuItemLength) {
								$($rows[1]).prepend($($rows[0]).find("li").eq(menuItemLength));
							}
							$($rows[1])
								.find("li")
								.each(function (index, element) {
									if (index > (menuItemLength-1)) {
										$(element).remove();
									}
								});
						}

						if (window.innerWidth <= 1120) {
							menuItemLength = 6;
							if($largeMenuWrapper.data("gaiiaMenu") == "yes") {
								menuItemLength = 9;
							}

							if ($($rows[0]).find("li").length > menuItemLength) {
								$($rows[1]).prepend($($rows[0]).find("li").eq(menuItemLength));
							}
							$($rows[1])
								.find("li")
								.each(function (index, element) {
									if (index > (menuItemLength-1)) {
										$(element).remove();
									}
								});
						}
					}
				}
			});
		}
		modifyMenu();
	}
})();

(function () {
	/* Set the width of the text notice on topbar (promotion topbar) */
	if ($(".header__top-notice").length > 0) {
		var $header_notice = $(".header__top-notice");
		var button_width = $header_notice.find(".button").css("width");
		$header_notice.find(".notice-text").css("max-width", "calc(100% - " + (parseInt(button_width) + 40) + "px)");
	}
})();

(function () {
	var $optionsContainer = $("#product_options_container");
	var $optionsPanel = $("#product_options_panel");
	var $selectedOptionContainer = $(".selected_option_container");

	var $optionsHeader = $optionsContainer.find(".options_header");
	var $selectedOption = $selectedOptionContainer.find(".selected_option");

	if ($optionsContainer.length) {
		function openOptionsPanel() {
			$("html, body").addClass("force-noscroll");
			$optionsContainer.fadeIn(250, function () {
				$optionsPanel.css({
					right: "0px",
				});
			});
		}

		function closeOptionsPanel() {
			$("html, body").removeClass("force-noscroll");
			$optionsPanel.css({
				right: "-360px",
			});
			$optionsContainer.fadeOut();
		}

		$selectedOptionContainer.on("click", function (e) {
			openOptionsPanel();
		});

		$optionsHeader.on("click", function () {
			closeOptionsPanel();
		});

		$optionsContainer.on("click", function (e) {
			if ($(e.target).attr("id") == "product_options_container") {
				closeOptionsPanel();
			}
		});

		$optionsPanel.find(".option").on("click", function () {
			if ($("body").data("productTemplateName") == "02-iso-bundle") {
				isoBundleOptionSelectedEvent.call(this);
			}else if ($("body").data("productTemplateName") == "reborn-express-main-page"){
				rebornExpressSelectedEvent.call(this);
			} else {
				defaultOptionSelectedEvent.call(this);
			}
		});

		function isoBundleOptionSelectedEvent() {
			__enableLoader(".bundle-ingredients");
			$(".bundle-ingredients-wrapper").css("height", $(".bundle-ingredients-wrapper").height());

			$("[data-add-to-cart]").data("productId", $(this).data("productId"));
			$("[data-add-to-cart]").attr("data-product-id", $(this).data("productId"));

			var payload = {
				packageProductId: $(this).data("productId"),
				parentId: $("body").data("productId"),
				optionId: $(this).data("optionId")
			};

			var self = this;
			$.ajax({
				type: "GET",
				url: window.jstransobj.linkPrefix + "/product/bundle-ingredients",
				data: payload,
				success: function (response) {
					$(".bundle-ingredients").replaceWith(response.html);

					var name = $(self).find(".option_name").data("bigcat");
					if(name.toLowerCase().indexOf("apple") !== -1) {
						name = "";
					}
					name += " " + $(self).find(".option_name").data("name");

					$("[update-model-name]").text(name.trim());
					$(".how-many-bundles-left .text").text(response.productArray.translations.howManyLeft);

					$('[update-old-price]').text(response.productArray.optionData.prices.oldPrice);
					$('[update-price]').text(response.productArray.optionData.prices.price);
					$('[discount-price]').text(response.productArray.optionData.prices.discountPrice);

					setTimeout(function () {
						$(".bundle-ingredients-wrapper").css("height", "auto");
					}, 1000);
				},
			});

			closeOptionsPanel();
		}

		function rebornExpressSelectedEvent() {
			$optionsPanel.find(".option").removeClass("selected");
			$(this).addClass("selected");

			var selectedOptionName = $(this).find('.option_name').data("name");
			$('.pms-selector .phone-name').html(selectedOptionName);
			$('.how-many-bundles-left .text').html($(this).find(".product-stock-status").data("stock-text"));

			closeOptionsPanel();

			var anchor = $(this).data("anchor");
			if(typeof anchor !== "undefined"){
				var scrollTag = $("p[id='"+ anchor +"']");
				$('html,body').animate({scrollTop: scrollTag.offset().top},'slow');
			}
		}

		function defaultOptionSelectedEvent() {
			if ($(this).find(".product-stock-status--false").length) {
				alert(window.jstransobj.outOfStock);
				return;
			}
			$optionsPanel.find(".option").removeClass("selected");
			$(this).addClass("selected");

			$selectedOption.find("img").attr("src", $(this).find("img").attr("src"));
			$selectedOption.find(".option_name").text($(this).find(".option_name").text());
			$selectedOption.find(".price").text($(this).find(".price").text());
			closeOptionsPanel();

			var optionId = $(this).data("optionId");
			$("#poptions")[0].selectedIndex = $("#poptions").find('[data-option-id="' + optionId + '"]')[0].index;
			$("#poptions").trigger("change");
		}
	}
})();

(function () {
	var $optionsContainer = $("#generated_options_container");
	var $optionsPanel = $("#generated_options_panel");
	var $selectedOptionContainer = $(".model-container.generated-options .clickable-overlay.open-options");
	var $gaiiaHeaderDeviceSelector = $(".header-gaiia .device-selector");

	var $optionsHeader = $optionsContainer.find(".options_header");

	if ($optionsContainer.length) {
		function openOptionsPanel() {
			$("html, body").addClass("force-noscroll");
			$optionsContainer.fadeIn(250, function () {
				$optionsPanel.css({
					right: "0px",
				});
			});
		}

		function closeOptionsPanel() {
			$("html, body").removeClass("force-noscroll");
			$optionsPanel.css({
				right: "-360px",
			});
			$optionsContainer.fadeOut();
			$('#generated_options_container .search_through_panel__input').val("").trigger("keyup");
		}

		$selectedOptionContainer.on("click", function (e) {
			e.preventDefault();
			openOptionsPanel();
		});

		$optionsHeader.on("click", function () {
			closeOptionsPanel();
		});

		$optionsContainer.on("click", function (e) {
			if ($(e.target).attr("id") == "generated_options_container") {
				closeOptionsPanel();
			}
		});

		if($gaiiaHeaderDeviceSelector.length) {
			$gaiiaHeaderDeviceSelector.on("click", function(e) {
				e.preventDefault();
				$selectedOptionContainer.trigger("click");
			});
		}
	}
})();

(function () {
	var $optionsContainer = $("#generated_colors_container");
	var $optionsPanel = $("#generated_colors_panel");
	var $selectedOptionContainer = $(".model-container.generated-options .clickable-overlay.open-colors");

	var $optionsHeader = $optionsContainer.find(".options_header");

	if ($optionsContainer.length) {
		function openOptionsPanel() {
			$("html, body").addClass("force-noscroll");
			$optionsContainer.fadeIn(250, function () {
				$optionsPanel.css({
					right: "0px",
				});
			});
		}

		function closeOptionsPanel() {
			$("html, body").removeClass("force-noscroll");
			$optionsPanel.css({
				right: "-360px",
			});
			$optionsContainer.fadeOut();
			$('#generated_colors_container .search_through_panel__input').val("").trigger("keyup");
		}

		$selectedOptionContainer.on("click", function (e) {
			e.preventDefault();
			openOptionsPanel();
		});

		$optionsHeader.on("click", function () {
			closeOptionsPanel();
		});

		$optionsContainer.on("click", function (e) {
			if ($(e.target).attr("id") == "generated_colors_container") {
				closeOptionsPanel();
			}
		});
	}
})();

function loadSimilarProducts() {
	$.get($("#similarProducts").data("url"), function (data) {
		$("#similarProducts").replaceWith(data);
		midCatStarRatings();
		setTimeout(function () {
			stretchProducts();
			displayProductRating();
		}, 1000);
		siteCoupon.registerEvents();
	});
}

function loadProductsBoughtWith() {
	$.get($("#productsBoughtWithThisProduct").data("url"), function (data) {
		$("#productsBoughtWithThisProduct").replaceWith(data);
		midCatStarRatings();
		setTimeout(function () {
			stretchProducts();
			displayProductRating();
		}, 1000);
		siteCoupon.registerEvents();
	});
}

function loadHardcodedProducts() {
	$.get($(".hardcodedProducts").data("url"), function (data) {
		$(".hardcodedProducts").html("");
		$(".hardcodedProducts").html(data);
		midCatStarRatings();
		setTimeout(function () {
			stretchProducts();
			displayProductRating();
		}, 1000);
		siteCoupon.registerEvents();
	});
}

function checkLoadSimilarProducts($similarProductsWrapper) {
	if ($similarProductsWrapper.isInViewport(-100)) {
		$similarProductsWrapper.attr("isLoaded", "loaded");
		loadSimilarProducts();
	}
}

function checkLoadProductsBoughtWith($productsBoughtWithThisProductWrapper) {
	if ($productsBoughtWithThisProductWrapper.isInViewport(-100)) {
		$productsBoughtWithThisProductWrapper.attr("isLoaded", "loaded");
		loadProductsBoughtWith();
	}
}

function checkLoadHardcodedProducts($hardcodedProducts) {
	if ($hardcodedProducts.isInViewport(-150)) {
		$hardcodedProducts.attr("isLoaded", "loaded");
		loadHardcodedProducts();
	}
}

function animateFreePostageFooterBar($footerFreePostageBar) {
	if ($footerFreePostageBar.isInViewport()) {
		$footerFreePostageBar.attr("isLoaded", "loaded");
		$footerFreePostageBar.animate({'width' : $footerFreePostageBar.data("percentage")});
	}
}

function animateMaterialSpecifications($materialSpecs) {
	if ($materialSpecs.isInViewport(180)) {
		$materialSpecs.attr("isAnimated", "yes");
		$(".score-wrapper").each(function () {
			var score = $(this).data("score");
			var delay = 200;
			var wrapperSelf = $(this);

			wrapperSelf.find("span").each(function (spanIndex) {
				var self = $(this);
				if (spanIndex < score) {
					setTimeout(function () {
						self.removeClass("blank");
					}, delay);
					delay += 200;
				}
				if (spanIndex >= 4) {
					setTimeout(function () {
						wrapperSelf.find(".score-number").addClass("animate__fadeInLeft");
					}, 1000);
				}
			});
		});
	}
}

function displayProductRating() {
	$(".listing__product,.product__top-of-the-week,.bestseller, .cart-cross-sell.product").each(function (index, element) {
		var productId = $(this).data("productId");
		var $listingProduct = $(this);

		if ($listingProduct.isInViewport(150)) {
			if (typeof productId != "undefined") {
				if ($listingProduct.data("requestCreated") != "yes") {
					$listingProduct.data("requestCreated", "yes");
					$.ajax({
						type: "GET",
						url: window.jstransobj.linkPrefix + "/product/rating/" + $(this).data("productId"),
						success: function (response) {
							if (response.rateCount != 0) {
								$listingProduct.find(".midcat-starRating-lazy").data("rating", response.avgRate);
								$listingProduct.find(".product-votes").html(response.rateCount);

								$listingProduct.find(".midcat-starRating-lazy").starRating({
									initialRating: $(this).data("score"),
									strokeColor: "#f2f2f2",
									strokeWidth: 10,
									starSize: 18,
									useGradient: false,
									emptyColor: "#f2f2f2",
									hoverColor: "#ffd969",
									activeColor: "#ffd969",
									readOnly: true,
								});

								if ($listingProduct.find(".based-on").length) {
									$listingProduct
										.find(".based-on")
										.text($listingProduct.find(".based-on").data("text").replace("%number%", response.rateCount));
								}

								if ($listingProduct.find(".product-midcat").length) {
									$listingProduct.find(".product-midcat").fadeOut(function () {
										$listingProduct.find(".ratings--lazyloaded").fadeIn();
									});
								} else {
									$listingProduct.find(".ratings--lazyloaded").fadeIn().css("opacity", "1");
								}
							} else {
								$listingProduct.find(".ratings--lazyloaded").slideUp();
							}
						},
					});
				}
			}
		}
	});
}

window.addEventListener("load", function () {
	var $materialSpecs = $(".material-specifications");
	var $similarProductsWrapper = $("#similarProductsWrapper");
	var $productsBoughtWithThisProductWrapper = $("#productsBoughtWithThisProductWrapper");
	var $hardcodedProducts = $(".hardcodedProducts");
	var $footerFreePostageBar = $('.free-ppt-progress-bar .progress-bar');

	window.addEventListener("scroll", function (e) {
		if ($similarProductsWrapper.length && $similarProductsWrapper.attr("isLoaded") !== "loaded") {
			checkLoadSimilarProducts($similarProductsWrapper);
		}
		if ($productsBoughtWithThisProductWrapper.length && $productsBoughtWithThisProductWrapper.attr("isLoaded") !== "loaded") {
			checkLoadProductsBoughtWith($productsBoughtWithThisProductWrapper);
		}
		if ($hardcodedProducts.length && $hardcodedProducts.attr("isLoaded") !== "loaded") {
			checkLoadHardcodedProducts($hardcodedProducts);
		}
		if ($materialSpecs.length && $materialSpecs.attr("isAnimated") !== "yes") {
			animateMaterialSpecifications($materialSpecs);
		}
		if ($footerFreePostageBar.length && $footerFreePostageBar.attr("isLoaded") !== "loaded") {
			animateFreePostageFooterBar($footerFreePostageBar);
		}
		displayProductRating();
	});

	if ($similarProductsWrapper.length) {
		checkLoadSimilarProducts($similarProductsWrapper);
	}
	if ($productsBoughtWithThisProductWrapper.length) {
		checkLoadProductsBoughtWith($productsBoughtWithThisProductWrapper);
	}
	if ($hardcodedProducts.length) {
		checkLoadHardcodedProducts($hardcodedProducts);
	}
	if ($materialSpecs.length) {
		animateMaterialSpecifications($materialSpecs);
	}
	displayProductRating();
});

function initiateFeaturedReviews() {
	if (!$(".swiper-container-featured-reviews").length) {
		return;
	}
	var videoPool = [];
	var imagePool = [];
	var ajaxPool = [];
	var ajaxPoolLength = $(".feautered-comment-uploads").length;

	var videoCounter = 0;

	function checkIfSlideExists(slide) {
		if ($("#product__feautered-reviews .swiper-slide").eq(slide).length == 0) {
			var swiperSlide = $('<div class="swiper-slide"></div>');
			$(".product__feautered-reviews .swiper-wrapper").append(swiperSlide);
		}
	}

	$(".feautered-comment-uploads").each(function (index, element) {
		var id = $(element).data("id");
		$.ajax({
			url: "https://media.wave.si/media.php?get_files&commentId=" + $(element).data("id"),
			dataType: "json",
			success: function (data) {
				var imageUrl = "";
				var wasMainImageInserted = false;
				if (data.length > 0) {
					videoThumbCounter = 0;
					if (typeof data[0].videos !== "undefined") {
						data[0].videos.forEach(function (el, index) {
							var $video = $('<video width="100%" height="auto" playsinline autoplay muted loop></video>');
							if(videoCounter > 0) {
								$video = $('<video width="100%" height="auto" playsinline autoplay muted loop></video>');
							}
							el.forEach(function (video, video_index) {
								if (video.indexOf("webm") !== -1) {
									$video.append('<source src="' + video + '" type="video/webm">');
								}
								if (video.indexOf("mp4") !== -1) {
									$video.append('<source src="' + video + '" type="video/mp4">');
								}
							});

							if (typeof data[1][videoThumbCounter] !== "undefined") {
								if (!wasMainImageInserted) {
									wasMainImageInserted = true;
									videoPool.push([$(element).parents(".swiper-slide-container").find(".main-image"), $video]);
								}
							}
							videoThumbCounter++;
							videoCounter++;
						});
					}
					if (typeof data[0].images !== "undefined") {
						data[0].images.forEach(function (el, index) {
							imageUrl = el.split("/");
							imageUrl.splice(imageUrl.length - 1, 0, "image_thumbnails");
							imageUrl = imageUrl.join("/");

							if (!wasMainImageInserted) {
								wasMainImageInserted = true;
								imagePool.push([$(element).parents(".swiper-slide-container").find(".main-image"), imageUrl]);
							}
						});
					}
				}
			},
			complete: function () {
				ajaxPool.push(1);
				if (ajaxPool.length === ajaxPoolLength) {
					var length = 3;
					var slide = 0;
					var counter = 0;

					if ($("body").data("productTemplateName") == "gaiia-main-page") {
						length = 4;
					}

					if (window.innerWidth <= 1024) {
						length = 2;
					}

					videoPool.forEach(function (element) {
						element[0].append(element[1]);

						// checkIfSlideExists(slide);

						// $("#product__feautered-reviews .swiper-slide").eq(slide).append(element[0].parents(".swiper-slide-container"));
						// counter++;
						// if (counter == length) {
						// 	counter = 0;
						// 	slide++;
						// }
					});
					imagePool.forEach(function (element) {
						element[0].attr("data-bg", element[1]).addClass("lazyload");

						// checkIfSlideExists(slide);

						// $("#product__feautered-reviews .swiper-slide").eq(slide).append(element[0].parents(".swiper-slide-container"));
						// counter++;
						// if (counter == length) {
						// 	counter = 0;
						// 	slide++;
						// }
					});

					var featuredReviews = new Swiper(".swiper-container-featured-reviews", {
						speed: 400,
						spaceBetween: 100,
						direction: "horizontal",
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
						autoHeight: true,
						observer: true,
						observeParents: true,
						observeSlideChildren: true,
						slidesPerView: 1,
						centeredSlides: true,
					});

					if ($("#product__feautered-reviews .swiper-slide").length > 1) {
						$("#product__feautered-reviews .swiper-button-next, #product__feautered-reviews .swiper-button-prev").show();
					}

					$(".product__feautered-reviews").addClass("expand");
				}
			},
		});
	});
}
initiateFeaturedReviews();

if ($(".product__template-isolation.template-with-image").length) {
	window.addEventListener("load", function () {
		window.addEventListener("scroll", function (e) {
			fadeInRichDescription();
		});
	});
}
setTimeout(function () {
	fadeInRichDescription();
}, 500);

function fadeInRichDescription() {
	var timeout, increase;
	$(".image-fade-into").each(function (index, el) {
		if (index == 0) {
			if ($(el).isInViewport(50) === true) {
				if (!$(el).hasClass("faded")) {
					$(el).addClass("faded");
				}
			}
		} else {
			if ($(el).isInViewport(50) === true) {
				if (!$(el).hasClass("faded")) {
					$(el).addClass("faded");
				}
			}
		}
	});
	$(".floating-cloud").each(function (index, el) {
		if ($(el).isInViewport(50) === true) {
			if (!$(el).hasClass("faded")) {
				setTimeout(function () {
					$(el).addClass("faded");
				}, 500);
				// timeout = 200;
				// $(el).find('.title-row').each(function(tlindex, tlel) {
				//     setTimeout(function() {
				//         $(tlel).addClass('faded');
				//     }, timeout);
				//     timeout += 80;
				// });
			}

			// $('.subtitle-fade-into').each(function(index, el) {
			//     if($(el).isInViewport() === true) {
			//         if(!$(el).hasClass('faded')) {
			//             $(el).addClass('faded');
			//         }
			//     }
			// });
		}
	});
}

$("#adminBarStockTree").on("click", function (event) {
	event.preventDefault();
	$(".stockTreeWrapper").toggle();
});

$(".stockTreeWrapper").on("click", function (event) {
	if ($(event.target).hasClass("stockTreeWrapper")) {
		$(".stockTreeWrapper").toggle();
	}
});

(function() {
    var animationId = null;
    var values = [-2,98,198,298,398];
    var isAnimationRunning = false;
    var speed = (311 * 0.2) / $('.header__top-notice .notice-text').first().width();
    var timeoutId = null;

    function resetTopbarAnimation() {
        values = [-2,98,198,298,398];
        $('.header__top-notice .notice-text').each(function (index, el) {
            $(this).css({
                '-webkit-transform' : 'translate(' + values[index] + '%,-50%)',
                '-moz-transform'    : 'translate(' + values[index] + '%,-50%)',
                '-ms-transform'     : 'translate(' + values[index] + '%,-50%)',
                '-o-transform'      : 'translate(' + values[index] + '%,-50%)',
                'transform'         : 'translate(' + values[index] + '%,-50%)'            
            });
        });    
    }

    function infiniteMarquee() {
        $('.header__top-notice .notice-text').each(function (index, el) {
            $(this).css({
                '-webkit-transform' : 'translate(' + values[index] + '%,-50%)',
                '-moz-transform'    : 'translate(' + values[index] + '%,-50%)',
                '-ms-transform'     : 'translate(' + values[index] + '%,-50%)',
                '-o-transform'      : 'translate(' + values[index] + '%,-50%)',
                'transform'         : 'translate(' + values[index] + '%,-50%)'            
            });
           
            if (values[index] < -100) {
                values[index] = 400;
            }        
            values[index] -= speed;
        });
        animationId = requestAnimationFrame(infiniteMarquee);
    }


	if($('.header__top-notice.infinite-scroll').length) {
		timeoutId = setTimeout(function() {        
			requestAnimationFrame(infiniteMarquee);
		}, 1500);
		isAnimationRunning = true;
		
		window.addEventListener('scroll', function() {
			if(isAnimationRunning) {
				if($('html, body').scrollTop() > 48) {
					cancelAnimationFrame(animationId);
					clearTimeout(timeoutId);
					resetTopbarAnimation();
					isAnimationRunning = false;
				}
			} else {
				if($('html, body').scrollTop() < 44) {
					timeoutId = setTimeout(function() {        
						requestAnimationFrame(infiniteMarquee);
					}, 1500);
					isAnimationRunning = true;
				}
			}
		});
	}

})();

$(document).ready(function() {
	if(document.querySelector('.all-story-wrapper') !== null){
		$.ajax({
			url: window.location.pathname + '/get-review-ids', 
			type: 'POST',
			success: function(response) {
				var counter = 0;
				var promises = [];
				response.comments.forEach(function(commentId) {
					promises.push($.ajax({
						url: "https://media.wave.si/media.php?get_files&commentId=" + commentId,
						dataType: "json",
						success: function (data) {
							var imageUrl = "";
							if (data.length > 0) {
								videoThumbCounter = 0;
								if (typeof data[0].videos !== "undefined") {
									data[0].videos.forEach(function (el, index) {
										var attribute = "";
										el.forEach(function (video, video_index) {
											if (video.indexOf("webm") !== -1) {
												attribute += " data-webm-video='" + video + "' ";
											}
											if (video.indexOf("mp4") !== -1) {
												attribute += " data-mp4-video='" + video + "' ";
											}
										});
		
										if (typeof data[1][videoThumbCounter] !== "undefined") {
											// $(element).append( $('<div class="commentUploadedFileWrapper"><div class="story-wrapper"><div class="play"></div><img class="commentUploadedFile video-thumbnail lazyload" '+ attribute +' data-src="'+data[1][videoThumbCounter]+'" /></div></div>') );
											$(document)
												.find(".all-story-wrapper")
												.append(
													gizzmoStories
														.getPrototype()
														.replace("%image_url%", data[1][videoThumbCounter])
														.replace("%story_id%", commentId)
												);
												counter++
										} else {
											$(document)
												.find(".all-story-wrapper")
												.append(
													$(
														'<img class="commentUploadedFile video lazyload" ' +
															attribute +
															' data-src="/assets/gizzmo/img/icons/icon-play.svg" />'
													)
												);
												counter++
										}
										videoThumbCounter++;
									});
								}
								if (typeof data[0].images !== "undefined") {
									data[0].images.forEach(function (el, index) {
										imageUrl = el.split("/");
										imageUrl.splice(imageUrl.length - 1, 0, "image_thumbnails");
										imageUrl = imageUrl.join("/");
										$(document)
											.find(".all-story-wrapper")
											.append(gizzmoStories.getPrototype().replace("%image_url%", imageUrl).replace("%story_id%", commentId));
										counter++
									});
								}
		
								if (typeof masonryGrid == 'object') {
									masonryGrid.masonry();
								}
							}
						},
					}));
				})
				Promise.all(promises)
				.then(function() {
					if(counter > 4){
						$(document)
							.find(".all-story-wrapper")
							.append('<div class="extra_media">+' + (counter - 4) + '</div>')
					}
				})
				
			},
			error: function(xhr, status, error) {
				console.error("An error occurred while fetching reviews:", error);
			}
		});
	}
})


function downloadProductReviewFiles() {
	$(".comment-uploads").each(function (index, element) {
		var _self = $(this);
		var id = $(element).data("id");
		if($(element).find(".story").length == 0){
			$.ajax({
				url: "https://media.wave.si/media.php?get_files&commentId=" + $(element).data("id"),
				dataType: "json",
				success: function (data) {
					var imageUrl = "";
					if (data.length > 0) {
						videoThumbCounter = 0;
						if (typeof data[0].videos !== "undefined") {
							data[0].videos.forEach(function (el, index) {
								var attribute = "";
								el.forEach(function (video, video_index) {
									if (video.indexOf("webm") !== -1) {
										attribute += " data-webm-video='" + video + "' ";
									}
									if (video.indexOf("mp4") !== -1) {
										attribute += " data-mp4-video='" + video + "' ";
									}
								});
	
								if (typeof data[1][videoThumbCounter] !== "undefined") {
									// $(element).append( $('<div class="commentUploadedFileWrapper"><div class="story-wrapper"><div class="play"></div><img class="commentUploadedFile video-thumbnail lazyload" '+ attribute +' data-src="'+data[1][videoThumbCounter]+'" /></div></div>') );
									$(element)
										.find(".story-wrapper")
										.append(
											gizzmoStories
												.getPrototype()
												.replace("%image_url%", data[1][videoThumbCounter])
												.replace("%story_id%", id)
										);
								} else {
									$(element)
										.find(".story-wrapper")
										.append(
											$(
												'<img class="commentUploadedFile video lazyload" ' +
													attribute +
													' data-src="/assets/gizzmo/img/icons/icon-play.svg" />'
											)
										);
								}
								videoThumbCounter++;
							});
						}
						if (typeof data[0].images !== "undefined") {
							data[0].images.forEach(function (el, index) {
								imageUrl = el.split("/");
								imageUrl.splice(imageUrl.length - 1, 0, "image_thumbnails");
								imageUrl = imageUrl.join("/");
								$(element)
									.find(".story-wrapper")
									.append(gizzmoStories.getPrototype().replace("%image_url%", imageUrl).replace("%story_id%", id));
							});
						}
	
						if (typeof masonryGrid == 'object') {
							masonryGrid.masonry();
						}
	
						if (typeof data[0].videos === "undefined" && typeof data[0].images === "undefined") {
							_self.remove();
						}

					}
				},
			});
		}
	});
}




$(" a.module___readmore").on("click", function (e) {
	e.preventDefault();
	openContent.call(this);
});

function openContent() {
	var $el = $(this).parents(".product__reviews").find(".add-gradient-after");
	if($el.length < 1){
		var $el = $(this).parent().find(".add-gradient-after");
	}
	var scrollTop = $(window).scrollTop();


		$el.addClass("open");
		$(this).addClass("open");
		$el.attr("scrollTop", scrollTop);
		$el.animate(
			{
				height: $el[0].scrollHeight,
			},
			function () {
				$el.css("height", "auto");
			}
		);
		$("body,html").animate(
			{
				scrollTop: scrollTop,
			},
			500
		);
		if (typeof $(this).data("readLess") != "undefined") {
			$(this).text($(this).data("readLess"));
		}
}

$(" a.module__readless").on("click", function (e) {
	e.preventDefault();
	$('#load-more-reviews').removeClass('disabled');
	closeContent.call(this);
});

function closeContent() {
	var $el = $(this).parents(".product__reviews").find(".add-gradient-after");
	if($el.length < 1){
		var $el = $(this).parent().find(".add-gradient-after");
	}
	var scrollTop = $(window).scrollTop();

		scrollTop = $el.attr("scrollTop");
		$el.removeClass("open");
		$(this).removeClass("open");
		$el.animate({
			height: $el.data("height"),
		});
		$("body,html").animate({
			scrollTop: scrollTop,
		});
		if (typeof $(this).data("readMore") != "undefined") {
			$(this).text($(this).data("readMore"));
		}
}
$(window).on("load" ,function() {
	if(document.querySelector('.zoomImg') && (document.querySelector('#floating-image-gaiia') || document.querySelector('#main-floating-images-gizzmo'))) {
		document.querySelector('.zoomImg').src = '';
	}

	if(document.querySelector('.zoomImg') && document.querySelector('#main-floating-images-gizzmo')) {
		$(".main-picture-container").trigger("zoom.destroy");
	}

	var mySwiper = new Swiper(".mySwiper", {
		speed: 400,
		spaceBetween: 100,
		direction: "horizontal",
		pagination: {
			el: ".swiper-pagination",
			dynamicBullets: !0,
			dynamicMainBullets: 7
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev"
		},
		autoHeight: !0,
		observer: !0,
		observeParents: !0,
		observeSlideChildren: !0,
		slidesPerView: 1,
		centeredSlides: !0
	});
});